import { useSelector } from 'react-redux';
import { RootState } from 'reducers/rootReducer';

const useBasicInfo = () => {
    const basicInfo = useSelector((state: RootState) => state.basicInfo);
    return basicInfo;
};
export default useBasicInfo;
